module.exports = __webpack_public_path__ + "static/media/weekend.db8e6979.webp";